import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import CommonMenuItem from '../common-menu/CommonMenuItem';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { SORT_ORDER } from '../../constants';
import CommonButton from '../common-button/CommonButton';

import '../common-menu/CommonMenu.scss';
import './SortDropdown.scss';

const SortMenu = ({ options = [], sort, direction, onApply }) => {
  const { t } = useTranslation();
  const [localeSort, setLocaleSort] = useState(sort);
  const [localeDirection, setLocaleDirection] = useState(direction);

  const handleChangeSort = useCallback((newSort) => {
    setLocaleSort(newSort.value);
  }, []);

  const handleChangeDirection = useCallback((newDirection) => {
    setLocaleDirection(newDirection);
  }, []);

  const handleApply = useCallback(() => {
    onApply({ sort: localeSort, direction: localeDirection });
  }, [onApply, localeSort, localeDirection]);

  return (
    <div className={clsx('common-menu', 'common-menu--no-submenu', 'sort-dropdown')}>
      <ul className='common-menu_options'>
        {options.map(({ value, label, disabled }) => (
          <CommonMenuItem
            key={value}
            isSelected={value === localeSort}
            label={label}
            value={value}
            disabled={disabled}
            onSelect={handleChangeSort}
          />
        ))}
      </ul>

      <div className='sort-dropdown_direction_wrapper'>
        <div
          className={clsx(
            'common-menu_item',
            'sort-dropdown_direction_item',
            localeDirection === SORT_ORDER.ASC && 'sort-dropdown_direction_item--selected',
            localeDirection === SORT_ORDER.ASC && 'common-menu_item--selected',
          )}
          onClick={() => handleChangeDirection(SORT_ORDER.ASC)}>
          Asc
          <Icon icon={ICONS.SortArrowTop} disableCommonColors />
        </div>

        <div
          className={clsx(
            'common-menu_item',
            'sort-dropdown_direction_item',
            'sort-dropdown_direction_item--desc',
            localeDirection === SORT_ORDER.DESC && 'common-menu_item--selected',
            localeDirection === SORT_ORDER.DESC && 'sort-dropdown_direction_item--selected',
          )}
          onClick={() => handleChangeDirection(SORT_ORDER.DESC)}>
          Desc
          <Icon icon={ICONS.SortArrowTop} disableCommonColors />
        </div>
      </div>

      <div className='sort-dropdown_action_wrapper'>
        <CommonButton type='button' styleColor='secondary' onClick={handleApply} maxWidth={120}>
          {t('apply')}
        </CommonButton>
      </div>
    </div>
  );
};

export default SortMenu;
